import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'

export interface NotificationContainerProps extends HTMLAttributes<HTMLDivElement> {
	isClickable?: boolean
}

export default function NotificationContainer({
	isClickable = false,
	...props
}: NotificationContainerProps) {
	return (
		<div
			data-clickable-feedback={!!isClickable}
			css={css`
				padding: 15px;
			`}
			{...props}
		/>
	)
}
